import { EventBookingUrlFragment } from 'generated/graphql'

export const EventBookingUrl =
    ({externalUrl}: EventBookingUrlFragment): string =>
        externalUrl